import {List} from 'immutable'

function getFeedbackInfo(state, system_type) {
    return state.getIn(['feedback', system_type, 'feedback', 'feedbacks'], List([]));
}

function getQuestions(state, system_type) {
    return state.getIn(['feedback', system_type, 'questions']);
}

function getFeedbacksById(state, systemType, systemId) {
    //HACK: Have to do this due to non-normalized state.
    const feedbacksFromPosts = state.getIn(['feedback', systemType, 'feedback', 'feedbacks']).filter(x => x.get('system_id') === systemId)
    if (feedbacksFromPosts.size > 0) return feedbacksFromPosts
    const feedbacksFromQuestions = state.getIn(['feedback', systemType, 'questions', 'feedbacks'])
    return feedbacksFromQuestions;
}

function getFeedbackRating(feedback) {
    return feedback.get('rating')
}

function hasDiscussed(feedback){

    if(feedback.get('feedback')){
        return true;
    }

    return false;
}

function getFeedbackSystemId(feedback) {
    return feedback.get('system_id')
}

function getFeedback(state, system_type) {
    return state.getIn(['feedback', system_type]);
}

function getUsermeta(state, system_type) {
    return state.getIn(['feedback', system_type, 'feedback', 'metas']);
}

function getNbrFeedbacks(state, system_type) {
    return state.getIn(['feedback', system_type, 'total']);
}

function getFeedbackCount(state){
    return state.getIn(['feedback', 'helpdesk', 'feedback', 'total'], 0);
}

function getCurrentItem(state) {
    return state.getIn(['feedback', 'currentItem'])
}

function getQuestionsCount(state){
    return state.getIn(['feedback', 'helpdesk', 'questions', 'questions_total'], 0);
}


export default {
    getFeedback,
    getUsermeta,
    getNbrFeedbacks,
    getFeedbackInfo,
    getFeedbackRating,
    hasDiscussed,
    getQuestions,
    getFeedbackSystemId,
    getFeedbackCount,
    getCurrentItem,
    getQuestionsCount,
    getFeedbacksById
}



// WEBPACK FOOTER //
// ./src/model/Feedback/selector.js